<template>
  <v-container>
    <div class="d-flex justify-space-between align-baseline mb-4">
      <div>
        <avs-switch
          mdi1="mdi-view-sequential"
          mdi2="mdi-view-module"
          :spantext="$t('messages.information.change_display')"
          @switch="v => changeDisplay(v)"
        />
      </div>
      <v-spacer></v-spacer>
      <div class="ml-auto">
        <avs-createButton
          v-if="$store.getters['app/canCreateProject']"
          :to="{ name: 'ProjectCreateUpdate' }"
          :spantext="$t('Nouvel espace evenementiel')"
          :name="$t('Nouvel espace')"
        />
      </div>
      <div></div>
    </div>
    <v-row v-if="loading">
      <v-col cols="3">
        <v-card>
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card>
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card>
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else-if="projects.length <= 0">
      <v-col>
        <template v-if="!$store.getters['app/canCreateProject']">
          {{ $t("messages.information.no_auth_create_project") }}
        </template>
        <template v-else>{{ $t("Vous n'avez aucun espace pour le moment") }}</template>
        <br />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col
        v-bind="layout"
        v-for="(p, i) in projects"
        :key="i"
      >
        <avs-card
          class="pb-0 mb-0 rounded-xl d-flex flex-wrap flex-column justify-space-between"
          height="100%"
          subtitle
          @click="selectProject(p)"
        >
          <template v-slot:title>
            <span class="text-h5 font-weight-bold">{{ p.name }}</span>
            <avs-role
              v-if="p.role"
              :role="p.role"
            />
          </template>
          <template v-slot:subtitle>
            <span> {{ p.company.name }}</span>
          </template>
          <template v-slot:content>
            <v-card-actions>
              <avs-button
                text
                color="accent"
                :spantext="$t('commons.explore')"
              >
                <template v-slot:name>{{ $t("commons.explore") }}</template>
              </avs-button>
              <v-spacer></v-spacer>
              <avs-editButton
                @click.stop="
                  () => $router.push({ name: 'ProjectCreateUpdate', params: { id: p.id } })
                "
                :disabled="isOperator(p.role)"
                :spantext="$t('actions.edit', { entity: $tc('Espace').toLowerCase() })"
              />

              <avs-deleteButton
                @click.stop="$event => handleOpenDeleteDialog(p)"
                :disabled="!isAdmin(p.role)"
                :spantext="$t('Supprimer l\'espace')"
              />
            </v-card-actions>
          </template>
        </avs-card>
      </v-col>
    </v-row>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      :resource="$tc('categories.project.name', 1)"
      @cancel="handleCancel"
      @delete="leave ? leaveProject() : removeProject()"
    />
  </v-container>
</template>

<script>
import { kebabCase } from "lodash"
import { ProjectService, DepartmentService } from "@/services"
import { toDate } from "@/utils/datetime"
import { isAdmin, isOperator } from "@/utils/middleware"

export default {
  name: "Projects",
  data() {
    return {
      deleteDialogIsOpen: false,
      loading: true,
      projects: [],
      departments: [],
      selectedDepartment: null,
      layouts: {
        col4: { cols: "12", md: "4", sm: "6", xs: "12" },
        col12: { cols: "12", md: "12", sm: "12", xs: "12" }
      },
      leave: false,
      selectedItem: null,
      layout: {},
      duplicateDialogIsOpen: false,
      selectedProjectId: null,
      form: {
        steps: true,
        tasks: true,
        inspections: true,
        non_conformities: true,
        actions: true,
        pcq_dsi: true,
        documentation: true,
        reports: true
      },
      itemToDuplicate: null
    }
  },
  created() {
    this.getProjects()
    this.getDepartments()
    if (this.$store.state.app.project) this.$store.commit("app/clearProject")
    this.layout = this.layouts.col4
  },
  computed: {
    departmentsWithExtras() {
      return [
        { id: null, name: this.$t("commons.all_simple") },
        { id: -1, name: this.$t("commons.not_assigned") },
        ...this.departments
      ]
    }
  },
  methods: {
    kebabCase,
    toDate,
    isOperator,
    isAdmin,
    changeDisplay(value) {
      this.layout = value ? this.layouts.col4 : this.layouts.col12
    },
    // leaveProject() {
    //   TeamService.selfRemove(this, this.selectedItem.id, this.$store.state.app.user.id).then(r => {
    //     this.$store.commit("app/message", {
    //       msg: "User removed from the project",
    //       color: "success"
    //     })
    //     this.getProjects()
    //   })
    //   this.deleteDialogIsOpen = false
    //   this.leave = false
    // },
    getDepartments() {
      DepartmentService.getDepartment(this.$store.getters["app/getCompany"].pk).then(response => {
        this.departments = response
      })
    },
    getProjects(departmentId = null) {
      this.loading = true
      let companyId = this.$store.getters["app/getCompany"].pk
      ProjectService.get(this, companyId, null, departmentId)
        .then(r => {
          this.projects = r.results
        })
        .finally(() => {
          this.loading = false
        })
    },
    // filterProjects() {
    //   this.getProjects(this.selectedDepartment)
    // },
    selectProject(p) {
      this.$store.commit("app/setProject", p)
      this.$router.push({ name: "Project" })
    },
    // duplicateProject(p) {
    //   this.itemToDuplicate = p
    //   this.selectedProjectId = p.id
    //   this.duplicateDialogIsOpen = true
    // },
    /* async duplicateProject(p) {
      ProjectService.get(this, null, p.id)
        .then(response => {
          // Override some keys
          response.name = `${response.name}-COPY`
          response.slug = `${response.slug}-copy`
          response.steps.forEach(step => {
            step.inspections = []
          })
          if (response.department) {
            response.department = response.department.id
          }
          response.validated_pcq_dsi = false
          ProjectService.create(this, response).then(r => {
            this.$store.commit("app/message", {
              msg: this.$t("messages.success.duplicated", {
                entity: this.$tc("categories.project.name", 1)
              }),
              color: "success"
            })
            this.getProjects()
          })
        })
        .catch(e => {
          if (e.response.status) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.not_allowed_duplicated"),
              color: "error"
            })
          }
        })
    },*/
    // async submitDuplication() {
    //   this.loading = true
    //   try {
    //     const response = await ProjectService.duplicate(this, this.selectedProjectId, this.form)

    //     this.duplicateDialogIsOpen = false

    //     this.$store.commit("app/message", {
    //       msg: this.$t("messages.success.duplicated", {
    //         entity: this.$tc("categories.project.name", 1)
    //       }),
    //       color: "success"
    //     })

    //     if (response?.new_project_id) {
    //       this.$router.push({ name: "project-view", params: { id: response.new_project_id } })
    //     }
    //   } catch (e) {
    //     const msg = this.$t("messages.error.not_allowed_duplicated")
    //     this.$store.commit("app/message", {
    //       msg,
    //       color: "error"
    //     })
    //   } finally {
    //     this.loading = false
    //     this.getProjects()
    //   }
    // },
    removeProject(p) {
      ProjectService.remove(this, this.selectedItem.id).then(r => {
        this.getProjects()
      })
      this.deleteDialogIsOpen = false
    },
    handleOpenDeleteDialog(item, leave = false) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
      this.leave = leave
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
      this.leave = false
    }
  }
}
</script>
